<div class="flex-100 layout-row-wrap responsive-column">
  <h4 class="mat-h4 flex-33">
    {{ textHeading | translateKey: 'heading' }}
  </h4>

  <div class="flex-63">
    <button type="button" mat-raised-button color="primary" [disabled]="!allowAddAccountingMapping" (click)="add()">
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Add' | translate }}
    </button>
  </div>
  @if (tableData.length !== 0) {
    <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="tableData">
      <ng-container matColumnDef="codeValueId">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.' + textField | translate }}</th>
        <td mat-cell *matCellDef="let item">
          {{ item.value.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="glAccountId">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.GL Account Name or Code' | translate }}</th>
        <td mat-cell *matCellDef="let item">({{ item.glAccount.glCode }}) {{ item.glAccount.name }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let item; let i = index">
          <button mat-icon-button color="primary" (click)="edit(item, i)">
            <fa-icon icon="edit"></fa-icon>
          </button>
          <button mat-icon-button color="warn" (click)="delete(i)">
            <fa-icon icon="trash"></fa-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableDisplayedColumns"></tr>
    </table>
  }
</div>
